import { RestSerializer } from 'miragejs';

export default RestSerializer.extend({});
